// WS timer Start

document.addEventListener("DOMContentLoaded", function(event) {
  // Function to update countdown
  function updateCountdown() {
    // Set the date we're counting down to (today at 23:59:00)
    var today = new Date();
    var countDownDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 0).getTime();

    // Update the countdown every second
    var x = setInterval(function() {
      // Get the current date and time
      var now = new Date().getTime();

      // Calculate the time remaining between now and the countdown date
      var distance = countDownDate - now;

      // Calculate hours, minutes, and seconds remaining
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Add leading zeros if the value is a single digit
      hours = String(hours).padStart(2, '0');
      minutes = String(minutes).padStart(2, '0');
      seconds = String(seconds).padStart(2, '0');

      // Display the countdown in the element with id="countdown"

      // If the countdown is over, reset for the next day
      if (distance < 0) {
        clearInterval(x);
        document.getElementById("countdown").innerHTML = "00:00:00";
        // Update countdown for the next day
        updateCountdown();
      }
    }, 1000); // Update every second
  }

  // Initial call to start countdown
  updateCountdown();
});



 // WS timer End 




  // Ws Function to calculate and update the shipping date
  function updateShippingDate() {
    const today = new Date();
    const shipDate = new Date(today);

    // Set the next day's shipping date
    shipDate.setDate(shipDate.getDate() + 1);

    // If the calculated shipping day is Sunday, move to Monday
    if (shipDate.getDay() === 0) {
      shipDate.setDate(shipDate.getDate() + 1);
    }

    // Format the date to display in English
    const options = { weekday: 'short', day: 'numeric', month: 'long' };
    const formattedDate = shipDate.toLocaleDateString('en-GB', options);

    // Update the element with the calculated shipping date
  }

  // Run the function after the DOM content is loaded
  document.addEventListener('DOMContentLoaded', updateShippingDate);


 //Ws Function to calculate and update the shipping date End 
